// extracted by mini-css-extract-plugin
export var closeButton = "_kp-1";
export var closeX = "_kp-3";
export var container = "_kp-0";
export var image = "_kp-2";